import { InjectionToken } from '@angular/core';

export const PASSWORD = new InjectionToken<string>('password');
export const UI_KEY = new InjectionToken<string>('uikey');
export const BASE_PATH = new InjectionToken<string>('basePath');
export const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}
